import React from 'react';
import './CompaniesTable.css';

function CompaniesTable({ companies, revenueSort, onRevenueSort }) {
  if (!companies || companies.length === 0) {
    return <p className="no-data">No companies match your search.</p>;
  }

  const columns = [
    'Company Name',
    'HQ Country',
    'HQ State',
    'HQ City',
    'Operating Geography',
    'Total Employees',
    'Year Founded',
    'Website',
    'Ownership Type',
    'Revenue ($)'
  ];

  const sortIcon = revenueSort === 'asc' ? ' ▲' : revenueSort === 'desc' ? ' ▼' : ' ⇅';

  return (
    <div className="table-wrapper">
      <table className="companies-table">
        <thead>
          <tr>
            {columns.map((col) =>
              col === 'Revenue ($)' ? (
                <th
                  key={col}
                  className="sortable-header"
                  onClick={onRevenueSort}
                  title="Click to sort by revenue"
                >
                  {col}{sortIcon}
                </th>
              ) : (
                <th key={col}>{col}</th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {companies.map((company, idx) => (
            <tr key={idx}>
              {columns.map((col) => (
                <td key={`${idx}-${col}`}>
                  {col === 'Website' ? (
                    company[col] && company[col] !== 'N/A' ? (
                      <a
                        href={company[col]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="website-link"
                      >
                        🔗 Visit
                      </a>
                    ) : (
                      'N/A'
                    )
                  ) : (
                    company[col]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CompaniesTable;
